import { myFetch, HttpMethod } from './baseService';

// Interfaz para la solicitud de ObtenerPorUnidadV2
export interface GetCuotaPorUnidadRequest {
  unidad_recidencial_codigo: string;
  codigo: string;
  apartamento_codigo: string;
  activo: string;
}

// Interfaz para la solicitud de InsertarV2
export interface InsertCuotaRequest {
  unidad_recidencial_codigo: string;
  Nombre: string;
  valor: number;
  link_Pago: string;
  Banco: string;
  cau_dia_pago: number;
  Default: 0 | 1;
}

// Interfaz para la solicitud de ModificarV2
export interface UpdateCuotaRequest {
  codigo: string;
  unidad_recidencial_codigo: string;
  Nombre: string;
  valor: number;
  link_Pago: string;
  Banco: string;
  cau_dia_pago: number;
  Default: 0 | 1;
  Activo: 0 | 1;
}

// Interfaz para el objeto de respuesta de la cuota administrativa
export interface CuotaAdmin {
  cau_codigo: number;
  cau_unidad_residencial: string;
  cau_nombre: string;
  cau_default: 0 | 1;
  cau_default_texto: string;
  cau_activo: 0 | 1;
  cau_activo_texto: string;
  cau_valor: number;
  cau_link_pago: string;
  cau_banco: string;
  cau_dia_pago: number;
}

// Interfaz genérica para la respuesta de la API
export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// Función para obtener cuotas por unidad residencial
export const getCuotaPorUnidad = async (payload: GetCuotaPorUnidadRequest) => {
  const envelope = await myFetch<ApiEnvelope<CuotaAdmin[]>>(
    'cuota_administracion_unidad/ObtenerPorUnidadV2',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

// Función para insertar una nueva cuota administrativa
export const insertCuota = async (payload: InsertCuotaRequest) => {
  const envelope = await myFetch<ApiEnvelope<CuotaAdmin[]>>(
    'cuota_administracion_unidad/InsertarV2',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

// Función para modificar una cuota administrativa existente
export const updateCuota = async (payload: UpdateCuotaRequest) => {
  const envelope = await myFetch<ApiEnvelope<CuotaAdmin[]>>(
    'cuota_administracion_unidad/ModificarV2',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};